<template>
  <div>
    <div class="container dashboard">
      <menuAdmin />
      <div>
        <form class="form-inline">
          <label class="sr-only" for="inlineFormInputName2">Ingresa palabra</label>
          <input type="text" class="form-control" id="inlineFormInputName2" placeholder="Ingresa palabra"
            v-model="palabra" />

          <button type="submit" class="primary-btn" :disabled="palabra.length == 0" @click="guardaPalabra">
            <i class="fa fa-bookmark mr-1" aria-hidden="true"></i>
            Añadir
          </button>
        </form>
      </div>
      <div class="row">
        <div class="col-12">
          <table class="table border rounded">
            <tr v-for="item in palabras" v-bind:key="item.id">
              <td class="titulo">
                <strong>{{ item.palabra }}</strong>
              </td>
              <td class="text-center">
                <button type="button" class="danger-icon-btn" @click="deleteItem(item.id)">
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuAdmin from "../components/MenuAdmin";
import fire from "./../fire";
export default {
  name: "AdminPalabras",
  components: { menuAdmin },
  data() {
    return {
      palabras: [],
      palabra: ""
    };
  },
  methods: {
    guardaPalabra() {
      const palabrota = {
        palabra: this.palabra
      };
      fire
        .database()
        .ref("palabras")
        .push(palabrota);
      this.palabra = "";
    },
    deleteItem(id) {
      console.log(id);
      let palabra = fire
        .database()
        .ref("palabras")
        .child(id);
      palabra.remove();
    }
  },
  mounted() {
    let viewMessage = this;
    const itemsRef = fire.database().ref("palabras");
    console.log(itemsRef);
    itemsRef.on("value", snapshot => {
      let data = snapshot.val();
      let palabras = [];
      Object.keys(data).forEach(key => {
        //console.log(data[key]);
        palabras.push({
          id: key,
          palabra: data[key].palabra
        });
      });
      viewMessage.palabras = palabras;
    });
  }
};
</script>

<style lang="scss">
img {
  &.imagen {
    width: 100px;
    height: auto;
  }
}

table td {
  vertical-align: middle;
}

.titulo {
  font-size: 1.1em;
}
</style>
